import { render, staticRenderFns } from "./UiCheckbox.vue?vue&type=template&id=0efa56d3&"
import script from "./UiCheckbox.vue?vue&type=script&lang=js&"
export * from "./UiCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./UiCheckbox.vue?vue&type=style&index=0&id=0efa56d3&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports